export class NoBrandsError extends Error {
  constructor (message) {
    super(message)
    this.name = 'NoBrandsError'
    this.message = message || 'No brands provided'
  }
}
